// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import InputField from './customFields/InputField';
import SelectField from './customFields/SelectField';
import { userTypeOptions } from '../../../utils/constans';
import { normalizePhoneInput } from '../../../utils/validators';

const specialCharRegex = /^[a-zA-Z0-9\s.,'-]*$/;

const requiredField = (value) => (
  value && value.trim() !== '' ? undefined : 'This field is required'
);

const validateNoSpecialChars = (value) => {
  if (!value) return undefined;
  return specialCharRegex.test(value) ? undefined : 'Special characters are not allowed';
};

const validateEmail = (value) => {
  if (!value) return 'This field is required';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value) ? undefined : 'Invalid email address';
};

const fieldProps = {
  paddingBottomClassName: '',
  inputClassName: 'dashboard-input',
};

let AddOrEditUsersForManagementReduxForm = ({ handleSubmit, closeModal, submitting }) => (
  <Form onSubmit={handleSubmit}>
    <div className="popup_body">
      <div className="field_col">
        <label className="field_name" htmlFor="firstName">
          First Name*
        </label>
        <Field
          id="firstName"
          name="firstName"
          component={InputField}
          type="text"
          placeholder="Type here..."
          maxLength={50}
          validate={[requiredField, validateNoSpecialChars]}
          {...fieldProps}
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="lastName">
          Last Name*
        </label>
        <Field
          id="lastName"
          name="lastName"
          component={InputField}
          type="text"
          placeholder="Type here..."
          maxLength={50}
          validate={[requiredField, validateNoSpecialChars]}
          {...fieldProps}
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="email">
          Email*
        </label>
        <Field
          id="email"
          name="email"
          component={InputField}
          type="email"
          placeholder="Type here..."
          maxLength={50}
          validate={validateEmail}
          {...fieldProps}
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="phone">
          Phone number*
        </label>
        <Field
          id="phone"
          name="phone"
          component={InputField}
          type="text"
          placeholder="Type here..."
          maxLength={15}
          normalize={normalizePhoneInput}
          validate={requiredField}
          {...fieldProps}
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="role">
          Role
        </label>
        <Field
          id="role"
          name="role"
          component={SelectField}
          options={userTypeOptions}
          type="select"
          placeholder="Select role"
          enableEmptyValue
          inputClassName="dashboard-input"
          paddingBottomClassName=""
        />
      </div>
    </div>

    <div className="popup_footer">
      <button
        className="dashboard-btn dashboard-btn--secondary"
        aria-label="cancel"
        type="button"
        onClick={closeModal}
      >
        Cancel
      </button>
      <button
        className="dashboard-btn dashboard-btn--primary"
        aria-label="save"
        type="submit"
        disabled={submitting}
      >
        Save
      </button>
    </div>
  </Form>
);

AddOrEditUsersForManagementReduxForm = reduxForm({
  form: 'AddOrEditUsersForManagementReduxForm',
  enableReinitialize: true,
})(AddOrEditUsersForManagementReduxForm);

export default withRouter(AddOrEditUsersForManagementReduxForm);
